module.exports = __webpack_public_path__ + "img/CS-Lite-Plus-Info.4f6af3fa.jpg";